<template>
  <CategoryTop :title="$t('trainings.online.categories.title')"
    :description="$t('trainings.online.categories.description')" v-if="extendedOnlineTrainigs()" />
</template>

<script setup>
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { showExtendedOnlineTrainings } from "@/composables/useProfileFieldCheck";


const { tenantConfig } = useTenantConfig();
const { extendedOnlineTrainigs } = showExtendedOnlineTrainings(tenantConfig);
</script>
